import { useEffect, useState } from 'react';
import useAxios from './useAxios';

const useSatisfactionSurveys = ({ options, ...axiosConfig } = {}) => {

  const [{ data, error, loading }, getSatisfactionSurveys] = useAxios({ url: '/satisfaction-surveys', ...axiosConfig }, options);

  const [satisfactionSurveys, setSatisfactionSurveys] = useState([]);
  const [total, setTotal] = useState(0);
  const [size, setSize] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  useEffect(() => {
    if (data) {
      setSatisfactionSurveys(data.data || []);
      setTotal(data?.meta?.total || 0);
      setSize(data?.meta?.per_page || 10);
      setNumberOfPages(data?.meta?.last_page || 0);
    }
  }, [data, loading, error]);

  return [{ satisfactionSurveys, total, numberOfPages, size, error, loading }, getSatisfactionSurveys];
};

export default useSatisfactionSurveys;
